// extracted by mini-css-extract-plugin
export var button = "landing-page-bestsellers-module--button--Sf-FV";
export var container = "landing-page-bestsellers-module--container--1C03x";